import React from "react";
import { generatePath, Link } from "react-router-dom";
import { EffectCards } from "swiper";
import { SwiperSlide, Swiper } from "swiper/react";
import "./SwiperMain.scss";

const SwiperMain = ({ info }) => {
  return (
    <Swiper
      spaceBetween={50}
      slidesPerView={1}
      style={{ width: "350px", backgroundColor: "transparent" }}
      effect={"cards"}
      grabCursor={true}
      modules={[EffectCards]}
      className="mySwiper"
    >
      {info.map((noticia) => {
        const backgroundImage = {
          backgroundImage: `url(${noticia.photo})`,
        };
        return (
          <SwiperSlide
            style={{ width: "350px", backgroundColor: "transparent" }}
            key={noticia._id}
          >
            {noticia.video && noticia.description ? (
              <Link
                className="link"
                to={generatePath("/novedades/:id", { id: noticia._id })}
              >
                <div className="cartaSwiper" style={backgroundImage}>
                  <div className="divIzquierdaSwiper">
                    <p className="shortDescription">
                      {noticia.shortDescription}
                    </p>
                    <h3 className="title">{noticia.title}</h3>
                  </div>
                </div>
              </Link>
            ) : (
              <div className="cartaSwiper" style={backgroundImage}>
                <div className="divIzquierdaSwiper">
                  <p className="shortDescription">{noticia.shortDescription}</p>
                  <h3 className="title">{noticia.title}</h3>
                </div>
              </div>
            )}
          </SwiperSlide>
        );
      })}
    </Swiper>
  );
};

export default SwiperMain;
